import React, { useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'
import Slider from 'react-slick'
import Spacer from '../../lib/spacer'
import ReadMoreButton from '../../common/read_more_button'
import { ClientOnly, useIsHydrated, useSlickA11yFix } from '../../util/ssr'

const Wrapper = styled.div`
    position: relative;

    ${(props) =>
        props.large &&
        css`
            background: ${props.theme.palette.greyScale.lightestGrey};
            border-radius: 12px;
            padding: 0 24px;

            .slick-dots {
                position: absolute;
                right: 30px;
                top: 5px;
                width: auto;
                height: 40px;
            }
        `}
`

const Content = styled.div`
    padding-right: ${(props) => (props.large ? 40 : 20)}px;
    padding-left: ${(props) => (props.large ? 0 : 20)}px;

    .button {
        padding-left: 0px;
        margin: 0px;
    }

    h3 {
        text-align: ${(props) => (props.large ? 'left' : 'center')};
        margin-bottom: 16px;
    }
`

export default ({ config, sliderIndex, setSliderIndex, large }) => {
    const slider = useRef()
    const isHydrated = useIsHydrated()
    const slickA11yRef = useSlickA11yFix()
    
    const sliderProps = {
        infinite: true,
        adaptiveHeight: true,
        speed: 500,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    }

    useEffect(() => {
        if (isHydrated && slider.current) {
            slider.current.slickGoTo(sliderIndex)
        }
    }, [sliderIndex, isHydrated])

    const staticFallback = (
        <Wrapper large={large}>
            <Spacer size={40} />
            <Content large={large}>
                <h3>{config[sliderIndex]?.title || config[0]?.title}</h3>
                {config[sliderIndex]?.description || config[0]?.description}
                <ReadMoreButton>{config[sliderIndex]?.readMore || config[0]?.readMore}</ReadMoreButton>
            </Content>
            <Spacer className="show-for-large" size={40} />
        </Wrapper>
    )

    return (
        <ClientOnly fallback={staticFallback}>
            <Wrapper large={large} ref={slickA11yRef}>
                <Spacer size={40} />
                <Slider
                    ref={slider}
                    beforeChange={(prev, next) => {
                        setTimeout(() => setSliderIndex(next))
                    }}
                    {...sliderProps}
                >
                    {config.map((config, index) => (
                        <Content large={large} key={index}>
                            <h3>{config.title}</h3>
                            {config.description}
                            <ReadMoreButton>{config.readMore}</ReadMoreButton>
                        </Content>
                    ))}
                </Slider>
                <Spacer className="show-for-large" size={40} />
            </Wrapper>
        </ClientOnly>
    )
}
